import '../vendor/hammer.min.js';

export default (slidesCount) => ({
  slide: 0,
  init() {
    this.slides = this.$refs.body.children.length;
    
    let hammertime = new Hammer(this.$el);
    hammertime.on('swipeleft', () => this.slideLeft());
    hammertime.on('swiperight', () => this.slideRight());
  },
  slideRight() {
    if (this.slide != 0) {
      -- this.slide;
      this.update();
    }
  },
  slideLeft() {
    if (this.slide != this.slides-1) {
      ++ this.slide;
      this.update();
    }
  },
  update() {
    this.$refs.body.style.transform = `translateX(-${this.slide * 100}%)`;
  }
})